import { useSelector } from "react-redux";

import VocaCardPage from "./study/VocaCardPage";
import MatchingPage from "./matching/MatchingPage";
import VocaExamPage from "./exam/VocaExamPage";
import UnknownCardPage from "./study/UnknownCardPage";

const VocabularyPage = ({ setCurrentStep, isPreview, isReview }) => {
  const { section } = useSelector((state) => state.assignment);

  if (section === null) {
    alert("모르는 단어가 없습니다.");
    setCurrentStep(2);
  } else if (section.type === "unknown") {
    return (
      <UnknownCardPage
        setCurrentStep={setCurrentStep}
        isPreview={isPreview}
        isReview={isReview}
      />
    );
  } else if (section.type === "study") {
    return (
      <VocaCardPage
        setCurrentStep={setCurrentStep}
        isPreview={isPreview}
        isReview={isReview}
      />
    );
  } else if (section.type === "matching") {
    return (
      <MatchingPage
        setCurrentStep={setCurrentStep}
        isPreview={isPreview}
        isReview={isReview}
      />
    );
  } else if (section.type === "exam") {
    return (
      <VocaExamPage
        setCurrentStep={setCurrentStep}
        isPreview={isPreview}
        isReview={isReview}
      />
    );
  }
  return <div></div>;
};

export default VocabularyPage;
